import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { Skeleton, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { Section } from '../../components/section';
import { CustomTooltip } from '../../components/tooltip';
import { totalPaymentData } from '../booking-summary/constants';

import { styles } from './styles';
import { getRowStyles } from './payment-plan';

export const PaymentPlanSkeleton: FC = () => {
    const { t } = useTranslation();
    return (
        <Section header={t('payment_plan_title')} withHeaderStipe>
            <Box css={[styles.paymentPlanLineItems]}>
                <Box css={css(styles.tableRow, styles.tableRowWithBorder)}>
                    <Box css={styles.firstCell}>
                        <Typography variant="h4" css={styles.paymentPlanColumnTitle}>
                            {t('payment_plan_payment_th')}
                        </Typography>
                    </Box>
                    <Box css={styles.secondCell}>
                        <Typography variant="h4" css={styles.paymentPlanColumnTitle}>
                            {t('payment_plan_due_date_th')}
                        </Typography>
                    </Box>
                    <Box css={styles.thirdCell}>
                        <Typography variant="h4" css={styles.paymentPlanColumnTitle}>
                            {t('payment_plan_amount_th')}
                        </Typography>
                    </Box>
                </Box>

                <Box css={css(styles.tableRowWithBorder)}>
                    <Box css={styles.tableSkeleton}>
                        <Typography variant="body2" css={styles.tableContent}>
                            <Skeleton />
                        </Typography>
                    </Box>
                    <Box css={styles.tableSkeleton}>
                        <Typography variant="body2" css={styles.tableContent}>
                            <Skeleton />
                        </Typography>
                    </Box>
                    <Box css={styles.tableSkeleton}>
                        <Typography variant="body2" css={styles.tableContent}>
                            <Skeleton />
                        </Typography>
                    </Box>
                </Box>

                <Box
                    css={css(
                        styles.tableSkeleton,
                        styles.tableRowWithBorder,
                        styles.tableRowWithDarkBorder
                    )}
                >
                    <Box css={getRowStyles(false, false)}>
                        <Box css={styles.firstCell}>
                            <Typography variant="body2" css={styles.tableContent}>
                                {t('payment_plan_total_payable')}
                            </Typography>
                        </Box>
                        <Box css={styles.thirdCell}>
                            <Typography variant="body2" css={styles.tableContent}>
                                <Skeleton />
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <Box
                    css={css(
                        styles.tableRow,
                        styles.tableRowWithBorder,
                        styles.tableRowWithDarkBorder
                    )}
                >
                    <Box css={[styles.firstCell, styles.twoRows]}>
                        <Typography variant="h3" css={styles.totalPay}>
                            {t(totalPaymentData.paymentLocale)}
                        </Typography>
                        <CustomTooltip
                            title={
                                <Typography variant="body4">
                                    <Skeleton />
                                </Typography>
                            }
                        />
                    </Box>
                    <Box css={styles.thirdCell}>
                        <Typography variant="h3" css={css(styles.totalPay, styles.totalPayAmount)}>
                            <Skeleton />
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Section>
    );
};
